import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Button, Stack, Typography } from "@financeable-com-au/financeable-ui";
import { creditCardModalInfo, payInvoiceModalInfo } from "@/constants";
import { usePaidServices } from "@/hooks";

interface PaidServicesTooltipContentProps {
  title: string;
  description: string;
  action: ReactNode;
}

const PaidServicesTooltipContent = ({ title, description, action }: PaidServicesTooltipContentProps) => (
  <Stack padding={2} flexDirection="column" rowGap={2} alignItems="flex-start">
    <Stack flexDirection="column" rowGap={1}>
      <Typography level="body-sm" bold>
        {title}
      </Typography>
      <Typography level="body-sm">{description}</Typography>
    </Stack>
    {action}
  </Stack>
);

const PaidServicesTooltip = () => {
  const { isInvoicePending, isServiceEnabled, numberOfPendingInvoices } = usePaidServices();

  if (isInvoicePending) {
    return (
      <PaidServicesTooltipContent
        title={payInvoiceModalInfo.mainTitle}
        description={payInvoiceModalInfo.SubTitle}
        action={
          numberOfPendingInvoices > 0 ? (
            <Link to={`/billing/transactions`}>
              <Button variant="secondary" size="sm">
                {payInvoiceModalInfo.btnText}
              </Button>
            </Link>
          ) : (
            <Typography level="body-xs">Please contact to your organisation</Typography>
          )
        }
      />
    );
  }

  if (!isServiceEnabled) {
    return (
      <PaidServicesTooltipContent
        title={creditCardModalInfo.mainTitle}
        description={creditCardModalInfo.subTitle}
        action={
          <Link to={`/billing/creditCard`}>
            <Button variant="secondary" size="sm">
              {creditCardModalInfo.btnText}
            </Button>
          </Link>
        }
      />
    );
  }

  return null;
};

export { PaidServicesTooltip };
